var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.717 3.5V5.41641C15.1236 5.65271 16.304 6.18923 17.3206 7.00517L15.5193 9.54926C14.3308 8.69504 13.0309 8.26793 11.8796 8.26793C11.0068 8.26793 10.5797 8.62076 10.5797 9.10358V9.14072C10.5797 9.73496 11.0254 9.99494 12.8452 10.4035C15.8164 11.0534 17.6734 12.0191 17.6734 14.4517V14.4889C17.6734 16.7607 16.1376 18.2442 13.717 18.6255V20.5H10.717V18.5865C9.06077 18.3152 7.53759 17.64 6.32715 16.5687L8.33271 14.1732C9.63261 15.1945 11.0439 15.7331 12.5481 15.7331C13.5323 15.7331 14.0523 15.3988 14.0523 14.8417V14.8046C14.0523 14.2475 13.6252 13.9689 11.8424 13.5418C9.07551 12.9104 6.93996 12.1305 6.93996 9.47498V9.43784C6.93996 7.36695 8.34746 5.78801 10.717 5.38091V3.5H13.717Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSolid);
export default __webpack_public_path__ + "static/media/dollar-solid.916de953d03e26fe681b8bf4cdd39c2d.svg";
export { ForwardRef as ReactComponent };